var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "reminders" },
    [
      _vm._l(_vm.reminders, function (reminder, i) {
        return _c("app-calendar-event-reminder", {
          key: i,
          attrs: { reminder: reminder },
          on: {
            remove: function ($event) {
              return _vm.$emit("remove", reminder)
            },
          },
        })
      }),
      _vm.showAdd
        ? _c(
            "w-link",
            {
              staticClass: "reminders-add",
              on: {
                click: function ($event) {
                  return _vm.add()
                },
              },
            },
            [
              _c("w-fa", { staticClass: "mrs", attrs: { icon: "plus" } }),
              _vm._v(" " + _vm._s(_vm.$ct("reminders.add")) + " "),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }